import { render } from "./AvatartType2.vue?vue&type=template&id=0efed92a&scoped=true"
import script from "./AvatartType2.vue?vue&type=script&lang=js"
export * from "./AvatartType2.vue?vue&type=script&lang=js"

import "./AvatartType2.vue?vue&type=style&index=0&id=0efed92a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efed92a"]])

export default __exports__